import React from "react";
import { ProductData, TInventoryTable } from "../interface";
import PlaceHolderImage from "../../../../../assets/Images/placeholderimg.png";
import { currencySymbol, getRegionTaxCode, numberWithCommas } from "../../../../../constants/utils";

export const inventoryColumns = (isNewInvoice: boolean) => [
  {
    name: "Product Type",
    selector: (row: TInventoryTable) => !row?.last_row ? (row.product_type?.name ?? "") : "Total",
    sortable: true,
  },
  {
    name: "Cover Photo",
    cell: (row: TInventoryTable) => !row?.last_row ? (row?.images?.length > 0 ? (
      <img
        src={row?.images?.[0] ?? PlaceHolderImage}
        alt="Cover"
        className="w-100 rounded object-contain"
      />
    ) : null) : '',
  },
  {
    name: "Brand",
    selector: (row: TInventoryTable) => !row?.last_row ? (row.brand?.brand_name ?? "") : '',
  },
  {
    name: "Model Number",
    selector: (row: TInventoryTable) => !row?.last_row ? (row.modal_number ?? "") : "",
  },
  {
    name: "Brand Color",
    selector: (row: TInventoryTable) => !row?.last_row ? (row.brand_color_code ?? "") : "",
  },
  {
    name: "Glass Size/Power",
    selector: (row: TInventoryTable) => !row?.last_row ? (row.glass_size ?? "") : "",
  },
  {
    name: `SRP (${currencySymbol()})`,
    selector: (row: TInventoryTable) => !row?.last_row ? (row.product_srp ?? numberWithCommas(row?.product_srp)) : "",
  },
  {
    name: "With Case",
    selector: (row: TInventoryTable) => !row?.last_row ? (row.product_with_case ? "Yes" : "No") : row?.additional_keys?.total_product_with_case
  },
  ...(isNewInvoice
    ? [{
      name: `${getRegionTaxCode()} (%)`,
      selector: (row: TInventoryTable) => !row?.last_row ? row?.product_type?.gst_percentage : "",
    }]
    : []
  ),

  {
    name: `Unit Cost Amount (${currencySymbol()})`,
    selector: (row: TInventoryTable) => !row?.last_row ? row.costAmount : "",
  },
  {
    name: `Discount(%)`,
    selector: (row: TInventoryTable) => !row?.last_row ? row.discount_percentage : "",
  },
  {
    name: `Discount Amount`,
    selector: (row: TInventoryTable) => !row?.last_row ? row.discount_amount : "",
  },
  {
    name: `Qty`,
    selector: (row: TInventoryTable) => !row?.last_row ? row.product_qty : row?.additional_keys?.qty,
  },
  {
    name: `Amount`,
    selector: (row: TInventoryTable) => row?.additional_keys?.subtotal_amount?.toFixed(2) ?? "",
  },
  ...(isNewInvoice
    ? [{
      name: `Total ${getRegionTaxCode()}`,
      selector: (row: TInventoryTable) => row?.additional_keys?.gst_amount?.toFixed(2) ?? "",
    }]
    : []
  ),
  {
    name: `Total Amount`,
    selector: (row: TInventoryTable) => (isNewInvoice) ? (row?.additional_keys?.grand_total_amount?.toFixed(2) ?? "") : (row?.additional_keys?.subtotal_amount?.toFixed(2) ?? ""),
  },


  {
    name: "Status",
    selector: (row: TInventoryTable) => !row?.last_row ? row?.is_Active : '',
  },
  {
    name: "Verification Status",
    selector: (row: TInventoryTable) => !row?.last_row ? row.verificationStatus : ''
  },
  {
    name: "Action",
    cell: (row: TInventoryTable) => !row?.last_row ? row.action : '',
  },
];


// for contact lens
export const contactLensColumns = (isNewInvoice: boolean) => [
  {
    name: "Product Type",
    selector: (row: ProductData, index: number) => row?.product_type?.name,
    sortable: true,
  },
  {
    name: "Brand",
    selector: (row: ProductData, index: number) => row?.brand?.brand_name,
  },
  {
    name: "Lens Color",
    selector: (row: ProductData | any, index: number) =>
      row.color?.color_name,
  },
  {
    name: `SRP (${currencySymbol()})`,
    selector: (row: ProductData, index: number) =>
      numberWithCommas(row.product_srp),
  },

  ...(isNewInvoice
    ? [{
      name: `${getRegionTaxCode()} (%)`,
      selector: (row: TInventoryTable) => !row?.last_row ? row?.product_type?.gst_percentage : "",
    }]
    : []
  ),
  {
    name: `Unit Cost Amount (${currencySymbol()})`,
    selector: (row: TInventoryTable) => !row?.last_row ? row?.costAmount : "",
  },
  {
    name: `Discount(%)`,
    selector: (row: TInventoryTable) => !row?.last_row ? row?.discount_percentage : "",
  },
  {
    name: `Discount Amount`,
    selector: (row: TInventoryTable) => !row?.last_row ? row.discount_amount : "",
  },
  {
    name: `Qty`,
    selector: (row: TInventoryTable) => !row?.last_row ? row.product_qty : row?.additional_keys?.qty,
  },
  {
    name: `Amount`,
    selector: (row: TInventoryTable) => row?.additional_keys?.subtotal_amount?.toFixed(2) ?? "",
  },
  ...(isNewInvoice
    ? [{
      name: `Total ${getRegionTaxCode()}`,
      selector: (row: TInventoryTable) => row?.additional_keys?.gst_amount?.toFixed(2) ?? "",
    }]
    : []
  ),
  {
    name: `Total Amount`,
    selector: (row: TInventoryTable) =>isNewInvoice ? (row?.additional_keys?.grand_total_amount?.toFixed(2) ?? "") : (row?.additional_keys?.subtotal_amount?.toFixed(2) ?? ""),
  },


  {
    name: "Status",
    selector: (row: TInventoryTable) => !row?.last_row ? row?.is_Active : '',
  },
  {
    name: "Verification Status",
    selector: (row: TInventoryTable) => !row?.last_row ? row.verificationStatus : ''
  },
  {
    name: "Action",
    cell: (row: TInventoryTable) => !row?.last_row ? row.action : '',
  },
];
